import React from 'react';
import { Input } from 'app/components/ui/input';
import { Label } from 'app/components/ui/label';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from 'app/components/ui/card';

import { DollarSign } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from 'app/components/ui/button';
import { selectSettings } from 'app/slice/selectors';
import { useSelector } from 'react-redux';

export default function CurrencySettings() {
  const settings = useSelector(selectSettings);
  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="flex items-center gap-2">
              <DollarSign className="w-5 h-5" />
              Currency Configuration
            </CardTitle>
            <CardDescription>
              Set up your store's currency and pricing display.
            </CardDescription>
          </div>
          <Link to="/settings/currencies">
            <Button>
              <a>Manage Currencies</a>
            </Button>
          </Link>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="currency">Currency *</Label>
            <Input
              id="currency"
              placeholder="USD"
              disabled={true}
              value={settings.currency_name}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="currency_symbol">Currency Symbol *</Label>
            <Input
              id="currency_symbol"
              placeholder={settings.currency_symbol}
              disabled={true}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="currency_code">Currency Code *</Label>
            <Input
              id="currency_code"
              placeholder={settings.currency_code}
              disabled={true}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="currency_decimals">Decimal Places</Label>
            <Input
              id="currency_decimals"
              placeholder={settings.currency_decimals}
              type="number"
              min="0"
              max="4"
              disabled={true}
              value={settings.currency_decimals}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
